export default {
  type: "this",
  category: "scope",
  groups: ["year 1", "year 2", "year 3", "year 4", "year 5", "year 6"],
};
